import { render, staticRenderFns } from "./pre_btn_pass_tan.vue?vue&type=template&id=5bb0f4d6&scoped=true"
import script from "./pre_btn_pass_tan.vue?vue&type=script&lang=js"
export * from "./pre_btn_pass_tan.vue?vue&type=script&lang=js"
import style0 from "./pre_btn_pass_tan.vue?vue&type=style&index=0&id=5bb0f4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb0f4d6",
  null
  
)

export default component.exports